module.exports = __webpack_public_path__ + "media/Video 4.7aff03e2.mp4";